var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app-bar', {
    attrs: {
      "app": "",
      "dense": ""
    }
  }, [_c('v-app-bar-nav-icon', {
    on: {
      "click": function ($event) {
        return _vm.toggleDrawer();
      }
    }
  }), _c('v-toolbar-title', {
    staticClass: "pl-1"
  }, [_c('div', {
    staticClass: "header-content",
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/products');
      }
    }
  }, [_c('scantrust-pro-logo-icon', {
    staticClass: "logo-icon",
    attrs: {
      "size": "32"
    }
  }), _c('scantrust-pro-text-icon', {
    staticClass: "text-logo",
    attrs: {
      "size": "115"
    }
  })], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }